import React, { useState, useRef, useEffect } from 'react';
import './Chat.css';

export default function Chat({ messages, onSend, userName }) {
  const [input, setInput] = useState('');
  const bottomRef = useRef(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  const handleSend = (e) => {
    e.preventDefault();
    if (!input.trim()) return;
    onSend(input.trim());
    setInput('');
  };

  const formatTime = (ts) => {
    const d = new Date(ts);
    return `${d.getHours().toString().padStart(2,'0')}:${d.getMinutes().toString().padStart(2,'0')}`;
  };

  return (
    <div className="chat">
      <div className="chat-messages">
        {messages.length === 0 && (
          <div className="chat-empty">Начните общение...</div>
        )}
        {messages.map(msg => (
          <div
            key={msg.id}
            className={`chat-msg ${msg.type === 'system' ? 'system' : ''} ${msg.userName === userName ? 'own' : ''}`}
          >
            {msg.type === 'system' ? (
              <span className="chat-system-text">{msg.text}</span>
            ) : (
              <>
                <div className="chat-msg-header">
                  <span className="chat-username">{msg.userName}</span>
                  <span className="chat-time">{formatTime(msg.timestamp)}</span>
                </div>
                <div className="chat-msg-text">{msg.text}</div>
              </>
            )}
          </div>
        ))}
        <div ref={bottomRef} />
      </div>

      <form className="chat-input-row" onSubmit={handleSend}>
        <input
          className="chat-input"
          type="text"
          value={input}
          onChange={e => setInput(e.target.value)}
          placeholder="Написать сообщение..."
          maxLength={500}
        />
        <button className="chat-send" type="submit" disabled={!input.trim()}>
          ↑
        </button>
      </form>
    </div>
  );
}
